import stores from './stores'

const isDev = (process.env.NODE_ENV === 'development')

// 获取微前端入口地址
const getMicroEntry = (path, port) => {
  if(isDev) {
    return `//localhost:${port}/`
  }
  return path
}

const genActiveRule = (routerPrefix: string[] | string, except?: string[]) => {
  return (location: Location) => {
    if (
      except &&
      except.some((url: string) => location.hash.startsWith(`#${url}`))
    ) {
      return false
    }
    if (Array.isArray(routerPrefix)) {
      return routerPrefix.some(url => location.hash.startsWith(`#/${url}`))
    }
    return location.hash.startsWith(`#/${routerPrefix}`)
  }
}

export const getMicroAppsConfig = (render)=>{
  return [
    {
      name: 'zn-web-admin', // app name registered
      entry: getMicroEntry('/znWeb/admin/', 3001),
      render,
      activeRule: genActiveRule([
        'admin',
        'practice-train',
        'micro-enterprises-learning',
        'train-plan-expense',
        'mili-top-u',
      ]),
      props: {
        stores,
      },
    },
    {
      name: 'micro-admin-bank-live', // 银行直播管理平台
      entry: getMicroEntry('/znWeb/micro-apps/admin-bank-live/', 3002),
      container: '#micro-app-root',
      activeRule: genActiveRule([
        'micro-admin-bank-live',
      ]),
      props: {
        stores,
      },
    },
    {
      name: 'zn-knowledge-cloud', // app name registered
      entry: getMicroEntry('/knowledge-cloud/', 8200),
      // container: '#root',
      render,
      activeRule: genActiveRule('knowledge-cloud'),
      props: {
        stores,
      },
    },
  ]
}

const setBodyAttributeMicro = val => document.body.setAttribute('_currentmicroapp', val)

export const microAppLifyCycle = (prefix = 'microapp') => ({
  beforeLoad: [
    app => {
      if (isDev) {
        console.log(app)
        // window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__ = `${(new URL(app.entry)).origin}/`
      }
      setBodyAttributeMicro(`${prefix}loading_${app.name}`)
    },
  ],
  beforeMount: [
    app => {
      setBodyAttributeMicro(`${prefix}_${app.name}`)
    }
  ],
  afterUnmount: [
    () => {
      setBodyAttributeMicro('')
    }
  ],
} as any)

